import React from "react";
import { Link } from "react-router-dom";
import { Flex } from "../../components/Flex";
import { Content } from "../../components/Layout";
import { Title } from "../../components/Text";
import { PackagesIcon } from "../../icons/PackagesIcon";
import { DashboardItem } from "../dashboard/Dashboard";

const AuditDashboard = (props) => {
    const {path} = props.match;

    const items = [
        {
            key: "download",
            title: "packages download",
            icon: <PackagesIcon />
        }
    ];

    return(
        <Content gap={{ bottom: 28 }}>
            <Title h3>Audit</Title>
            <Flex gap={{ right: 32 }} >
                {items.map((item) => (
                    <Link key={item.key} to={path + "/" + item.key}>
                        <DashboardItem
                            title={item.title}
                            icon={item.icon}
                        />
                    </Link>
                ))}
            </Flex>
        </Content>
    )
}

export { AuditDashboard };